import { render, staticRenderFns } from "./NonAcademicStep.vue?vue&type=template&id=7678a794&scoped=true&"
import script from "./NonAcademicStep.vue?vue&type=script&lang=js&"
export * from "./NonAcademicStep.vue?vue&type=script&lang=js&"
import style0 from "./NonAcademicStep.vue?vue&type=style&index=0&id=7678a794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7678a794",
  null
  
)

export default component.exports